require('@smithy/service-error-classification');
require('@smithy/middleware-serde');
require('@smithy/middleware-endpoint');

try {
    require('@smithy/core/endpoints');
} catch {
    /* optional */
}
